import { Dispatch, SetStateAction } from 'react'
import { Button, DSButtonType } from 'components'
import { ModalContentLayout } from 'layouts/ModalContentLayout'

import * as S from './styles'

type QuotaSelectModalProps = {
  title: string
  description: string
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
}

const QuotaSelectModal = ({
  title,
  description,
  open,
  setOpen
}: QuotaSelectModalProps) => {
  const closeAction = () => {
    setOpen(false)
  }

  return (
    <>
      {open && (
        <ModalContentLayout
          title={title}
          description={description}
          closeAction={closeAction}
        >
          <S.Actions>
            <Button
              color="primary"
              content="Entendi"
              design={DSButtonType.PRIMARY_BUTTON}
              onClick={closeAction}
              fullWidth={false}
            />
          </S.Actions>
        </ModalContentLayout>
      )}
    </>
  )
}

export default QuotaSelectModal
